import { render } from "./CustomerForm.vue?vue&type=template&id=7a7cea65&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"

import "./CustomerForm.vue?vue&type=style&index=0&id=7a7cea65&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7cea65"]])

export default __exports__